import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-learning-center-section',
    template: `
    @if (layout === 'icon') {
      <div class="tw-w-full tw-flex app-pb1 app-pt1">
        <div class="tw-grow-0 app-pr2 tw-hidden md:tw-block">
          <mat-icon class="icon-big">{{ icon }} </mat-icon>
        </div>
        <div class="tw-grow">
          <h3 class="app-lc-header-3" role="heading">
            {{ label }}
          </h3>
          <div [ngTemplateOutlet]="content"></div>
        </div>
      </div>
    }
    
    @if (layout === 'bullet') {
      <div class="tw-w-full tw-flex app-pb1 app-pt1">
        <div class="tw-grow-0 app-pr2 tw-items-stretch">
          <div class="bullet-big tw-align-middle">
            {{ icon }}
          </div>
        </div>
        <div class="tw-grow">
          <h3 class="app-lc-header-3" role="heading">
            {{ label }}
          </h3>
          <div [ngTemplateOutlet]="content"></div>
        </div>
      </div>
    }
    
    @if (layout === 'icon-small') {
      <div class="tw-flex tw-flex-col tw-flex-wrap app-p1">
        <div class="tw-text-center">
          <mat-icon class="">{{ icon }} </mat-icon>
        </div>
        <div class="tw-text-center">
          <div [ngTemplateOutlet]="content"></div>
        </div>
      </div>
    }
    
    <ng-template #content>
      <ng-content></ng-content>
    </ng-template>
    `,
    styles: [
        `
      .margin {
        margin: 10px;
      }

      .icon-big {
        width: 48px;
        height: 48px;
        font-size: 48px;
        color: var(--sed-purple-40-color);
      }

      .bullet-big {
        background-color: var(--sed-purple-40-color);
        color: var(--sed-engaged-black-color);
        padding: 10px;
        border-radius: 5px;
        font-size: 24px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 600;
      }
    `,
    ],
    standalone: false
})
export class LearningCenterSectionComponent {
  @Input()
  label: string;

  @Input()
  icon: string;

  @Input()
  layout: SectionLayout;
}

export type SectionLayout = 'icon' | 'bullet' | 'icon-small';
